import type { GuideTargetId, PageGuideDefinition } from "./types";

export const GUIDE_TARGET_ATTR = "data-guide";

export function guideSelector(target: GuideTargetId): string {
  return `[${GUIDE_TARGET_ATTR}="${target}"]`;
}

/** Spread onto any element to mark it as a guide step target. */
export function guideTargetProps(target: GuideTargetId) {
  return { [GUIDE_TARGET_ATTR]: target } as const;
}

export function isGuideTargetPresent(target: GuideTargetId): boolean {
  return Boolean(document.querySelector(guideSelector(target)));
}

export function guideHasVisibleSteps(guide: PageGuideDefinition): boolean {
  return guide.steps.some((step) => isGuideTargetPresent(step.target));
}
